import { render, staticRenderFns } from "./RecruitmentComponent.vue?vue&type=template&id=149b680e&scoped=true"
import script from "./RecruitmentComponent.vue?vue&type=script&lang=js"
export * from "./RecruitmentComponent.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentComponent.vue?vue&type=style&index=0&id=149b680e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b680e",
  null
  
)

export default component.exports